import * as d3 from "d3";
import { D3Selection } from "svg/draw/draw-calendar";
import { Dimensions, Placement } from "burde";
//This has to be done for the shadow to work.
//Split in to two functions to make it possible to reuse in the same svg
const addSvgDropShadowDef = (svg: D3Selection) => {
    var defs = svg.select("defs");

    if (defs.empty()) {
        defs = svg.append("defs");
    }

    var filter = defs
        .append("filter")
        .attr("id", "drop-shadow")
        .attr("height", "130%");

    // SourceAlpha refers to opacity of graphic that this filter will be applied to
    // convolve that with a Gaussian with standard deviation 3 and store result
    // in blur
    filter
        .append("feGaussianBlur")
        .attr("in", "SourceAlpha")
        .attr("stdDeviation", 40)
        .attr("result", "blur");

    // translate output of Gaussian blur to the right and downwards with 2px
    // store result in offsetBlur
    filter
        .append("feOffset")
        .attr("color", "red")
        .attr("in", "blur")
        .attr("dx", -20)
        .attr("dy", 20)
        .attr("result", "offsetBlur");

    filter
        .append("feFlood")
        .attr("flood-color", "rgba(0,0,0,0.25")
        .attr("result", "offsetColor");
    filter
        .append("feComposite")
        .attr("in", "offsetColor")
        .attr("in2", "offsetBlur")
        .attr("operator", "in")
        .attr("result", "offsetBlur");

    // overlay original SourceGraphic over translated blurred opacity by using
    // feMerge filter. Order of specifying inputs is important!
    var feMerge = filter.append("feMerge");

    feMerge.append("feMergeNode").attr("in", "offsetBlur");
    feMerge.append("feMergeNode").attr("in", "SourceGraphic");
};

const addRubberBandDropShadowDef = (svg: D3Selection) => {
    var defs = svg.select("defs");

    if (defs.empty()) {
        defs = svg.append("defs");
    }

    var filter = defs.append("filter").attr("id", "rubber-band-drop-shadow");

    filter
        .append("feGaussianBlur")
        .attr("in", "SourceGraphic")
        .attr("stdDeviation", 5);
};

const drawSvgDropShadow = (
    svg: D3Selection,
    dimensions: Dimensions,
    placement: Placement,
) => {
    if (svg.select("#drop-shadow").empty()) {
        addSvgDropShadowDef(svg);
    }

    svg.append("rect")
        .attr("width", dimensions.Width)
        .attr("height", dimensions.Height)
        .attr("transform", `translate(${placement.X}, ${placement.Y})`)
        .attr("fill", "white")
        .style("filter", `url(${location.href}#drop-shadow)`);
};

export { drawSvgDropShadow, addRubberBandDropShadowDef };
